import Section from '../../../components/Section';
import Indicator from '../../../components/Indicator';
import {IDashboardData} from '../../../utils/types';

interface Props {
    data: IDashboardData;
}

const CollaborazioniSection = ({data}: Props) => (
    <Section title='III. INIZIATIVE CON COLLABORAZIONI'>
        <Indicator
            roman=''
            title='Iniziative collaborative previste a confronto con la media'
            tooltip='Il grafico mostra la percentuale di iniziative previste nel vostro progetto che sono frutto di collaborazioni, a confronto con la media dello stesso valore calcolata per tutti i progetti. La percentuale media si ottiene calcolando, per ciascun progetto, la percentuale di iniziative con collaborazioni. Queste percentuali vengono poi mediate su tutti i progetti.'
            data={data['question11_item-1']}
            maxOverride={100}
        />
    </Section>
);

export default CollaborazioniSection;
